module.exports = __webpack_public_path__ + "static/fowf-advisor-1-cc3013af21dd8af830dcddf972e88ff2.jpg";